const packageFilterStored = JSON.parse(
  localStorage.getItem("packageFilterStored") as string
);
const initialState = packageFilterStored
  ? { packageFilter: packageFilterStored }
  : { packageFilter: {} };

export const packageFilter = {
  namespaced: true,
  state: initialState,
  actions: {
    setPackageFilter({ commit }: any, current: { filter: any; index: any }) {
      commit("setPackageFilter", current);
      localStorage.setItem(
        "packageFilterStored",
        JSON.stringify(this.state.packageFilter.packageFilter)
      );
    },
  },
  mutations: {
    setPackageFilter(state: any, current: any) {
      state.packageFilter[current.index] = current.filter;
    },
  },
};
